import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { MessageService } from './message.service';
import { NavigationService } from '../navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import decode from 'jwt-decode';
import { data } from 'jquery';
import { WINDOW_PROVIDERS } from 'app/shared/helpers/window.helper';
import { throwToolbarMixedModesError } from '@angular/material';
import { Subject } from 'rxjs';
import { SubMenuStatus } from 'app/shared/models/global/sub-menu-status';

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    loginUserFirstName = '';
    loginUserLastName = '';
    country_list: any = [];
    state_list: any = [];
    Nature_of_business: any;
    natureOfBusinessList: any = [];
    oivaibale = 2;
    deductionEEAEEB: any = true;
    allassessmentYearList: any = [];
    assessmentYearList: any = [];
    selectedAssessmentYear: any = [];
    storeData: any = null;
    pmtInfoA: boolean = false;
    pmtInfoB: boolean = false;
    pmtInfoC: boolean = false;
    pmtInfoD: boolean = false;
    pmtInfoE: boolean = false;
    pmtpartnertwo: boolean = false;
    hideComponent = true;
    perquisites = false;
    retirement = false;
    pmtdesignation: boolean = false;
    tabOneActive = true;
    tabTwoActive = false;
    tabThreeActive = false;
    normalratetti: boolean = false;
    specialRatetti: boolean = false;
    agrIncometti: boolean = false;

    substatusdisable: boolean = false;
    substatusllp: boolean = false;
    companyStatus: boolean = false;
    producerComapny: boolean = false;
    disbalecfl: boolean = false;
    otherInfodisable: boolean = false;
    bpdisable: boolean = false;
    pldisable: boolean = false;
    deduction80GGC: boolean = false;
    restricpagepl: boolean = false;
    isApplicableForItr5: boolean = false;

    pl4ada = 10;

    navigatedPage = 'dashboard';
    deduction80GCorrectionLimit = 0;

    selectedValue = null;
    businessList = null;
    selectedBusiness = null;
    salaryFormcounter = null;
    salarybasic_pay = 0;
    salaryCommission = 0;

    houseProperty = {
        rented: 0,
        self_occupied: 0,
        deemed: 0,
    };
    housePropertyArray = null;
    housePropertyTeenantsArray = null;

    itrListFull = [];
    itrList: any = [];
    selectedItr: any = [];
    selectedItrName = null;

    pincodeData: any = null;

    partyMap = null;
    personID: any = null;
    selectedYearId: any = null;
    selectedItrId = null;
    assessmentYear = null;
    tokenData = null;
    partyData = null;
    display_dropdown: Boolean = true;
    partyTypeValue: any = null;

    tempItrId: any = null;

    navDisable = false;

    partyName = '';

    changesFromFinancial = true;

    isHufOfItr2 = false;

    isTypeOfCompany = false;

    // this is only used in Dpm Doa ======//
    restrictLoader: boolean = false;
    subStatus: any = null;
    substatusId: any;

    profitlossSave: boolean = false;

    subMenuValue: Subject<SubMenuStatus> = new Subject<SubMenuStatus>();

    ayItrMap = new Map();

    constructor(
        public api: ApiService,
        public auth: AuthService,
        public message: MessageService,
        public navigation: NavigationService,
        public router: Router,
        public activatedRoute: ActivatedRoute
    ) {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params['comp']) {
                localStorage.clear();
            } else {
                this.tempItrId = params['itr_id'];
                this.selectedItrId = +params['itr_id'];
                if (this.changesFromFinancial) {
                    this.updateCommon();
                }
            }
            if (this.personID && this.selectedYearId) {
                if (this.selectedItrId === 5) {
                    this.getSubStatus(this.personID, this.selectedYearId);
                }
                if (this.selectedItrId === 6 || this.selectedItrId === 1 || this.selectedItrId === 4 || this.selectedItrId === 2 || this.selectedItrId === 3 || this.selectedItrId === 5) {
                    this.getSubMenuStatus(this.personID, this.selectedYearId, false);
                }
            }
            this.getAllParties();
        });
    }

    updateCommon() {
        this.changesFromFinancial = true;
        const storedToken = localStorage.getItem('token') || null;
        const financialYear = localStorage.getItem('financial_year') || null;
        const partyType = localStorage.getItem('party_type') || null;
        this.loginUserFirstName = localStorage.getItem('loginUserFName') || null;
        this.loginUserLastName = localStorage.getItem('loginUserLName') || null;
        // console.log("partyType......common",partyType,this.loginUserFirstName);
        if (storedToken) {
            this.tokenData = JSON.parse(decode(storedToken).sub);
            this.personID = this.tokenData['personId'];
            this.selectedYearId = this.tokenData['financialId'];
        }
        if (partyType) {
            this.partyData = JSON.parse(atob(partyType));
            this.partyTypeValue = parseInt(this.partyData['party_type'], 10);
            this.partyName = this.partyData.first_name + ' ' + this.partyData.last_name;

            if (this.partyData.selected_itr_id === 2 && this.partyData.party_type === 2) {
                this.isHufOfItr2 = true;
            }
        }
        if (financialYear) {
            const year = JSON.parse(atob(financialYear));
            this.selectedAssessmentYear = year;
            this.selectedYearId = year.id;
            this.assessmentYear = year.assessment_year ? year.assessment_year.split('-')[0] : '';
        }
        if (partyType && storedToken) {
            this.getAssessmentYearList();
            this.getItrFormList();
        }
    }

    getItrFormList() {
        this.message.loading = true;
        this.api.get('formMaster/list').subscribe(
            res => {
                this.message.loading = false;
                if (res['status']) {
                    this.itrListFull = res['data'];
                    this.itrOption();
                } else {
                    this.message.displaySnackbar(res['message']);
                }
            },
            err => {
                this.message.loading = false;
                this.message.displaySnackbar('Oops, Something went wrong!');
            }
        );
    }

    // itrOption() {
    //     const partyType = localStorage.getItem('party_type') || null;
    //     if (partyType) {
    //         this.selectedItrId = this.selectedItrId ? this.selectedItrId : parseInt(this.tempItrId, 10);
    //         const party = JSON.parse(atob(partyType));
    //         this.partyData = JSON.parse(atob(partyType));
    //         if (party.party_type === 1) {
    //             this.ayItrMap.set(1,  'ITR1');
    //             this.ayItrMap.set(2,  'ITR3');
    //             this.ayItrMap.set(3,  'ITR1');
    //             this.selectedItrName = party.itrselected === null ? this.ayItrMap.get(this.selectedYearId) : party.itrselected;
    //             const tempArr = [];
    //             this.itrListFull.forEach(element => {
    //                 if (
    //                     element['form_type'] === 'ITR1' ||
    //                     element['form_type'] === 'ITR2' ||
    //                     element['form_type'] === 'ITR3' ||
    //                     element['form_type'] === 'ITR4'
    //                     //======= please don't uncomment because it is not showing in Individaul case========
    //                     // element['form_type'] === 'ITR5' ||
    //                 //    element['form_type'] === 'ITR6'
    //                 ) {
    //                     tempArr.push(element);
    //                 }
    //                 if (element['form_type'] === this.selectedItrName) {
    //                     this.selectedItrId = element['id'];
    //                 }
    //             });
    //             this.itrList = tempArr;
    //         }
    //         if (party.party_type === 2) {
    //             this.selectedItrName = party.itrselected === null ? `ITR4` : party.itrselected;
    //             const tempArr = [];
    //             this.itrListFull.forEach(element => {
    //                 if (
    //                     element['form_type'] === 'ITR2' ||
    //                     element['form_type'] === 'ITR3' ||
    //                     element['form_type'] === 'ITR4'
    //                 ) {
    //                     tempArr.push(element);
    //                 }
    //                 if (element['form_type'] === this.selectedItrName) {
    //                     this.selectedItrId = element['id'];
    //                 }
    //             });
    //             this.itrList = tempArr;
    //         }
    //         if (party.party_type === 3) {
    //             this.selectedItrName = party.itrselected === null ? `ITR5` : party.itrselected;
    //             const tempArr = [];
    //             this.itrListFull.forEach(element => {
    //                 if (element['form_type'] === 'ITR4' ||
    //                     element['form_type'] === 'ITR5'
    //                 ) {
    //                     tempArr.push(element);
    //                 }
    //                 if (element['form_type'] === this.selectedItrName) {
    //                     this.selectedItrId = element['id'];
    //                 }
    //             });
    //             this.itrList = tempArr;
    //         }
    //         if (party.party_type === 4) {
    //             this.selectedItrName = party.itrselected === null ? 'ITR5' : party.itrselected;
    //             const tempArr = [];
    //             this.itrListFull.forEach(element => {
    //                 if (
    //                     element['form_type'] === 'ITR5'
    //                 ) {
    //                     tempArr.push(element);
    //                 }
    //                 if (element['form_type'] === this.selectedItrName) {
    //                     this.selectedItrId = element['id'];
    //                 }
    //             });
    //             this.itrList = tempArr;
    //         }
    //         if (party.party_type === 5) {
    //             this.selectedItrName = party.itrselected === null ? 'ITR5' : party.itrselected;
    //             const tempArr = [];
    //             this.itrListFull.forEach(element => {
    //                 if (
    //                     element['form_type'] === 'ITR5'
    //                 ) {
    //                     tempArr.push(element);
    //                 }
    //                 if (element['form_type'] === this.selectedItrName) {
    //                     this.selectedItrId = element['id'];
    //                 }
    //             });
    //             this.itrList = tempArr;
    //         } if (party.party_type === 6) {
    //             this.selectedItrName = party.itrselected === null ? 'ITR5' : party.itrselected;
    //             const tempArr = [];
    //             this.itrListFull.forEach(element => {
    //                 if (
    //                     element['form_type'] === 'ITR5'
    //                 ) {
    //                     tempArr.push(element);
    //                 }
    //                 if (element['form_type'] === this.selectedItrName) {
    //                     this.selectedItrId = element['id'];
    //                 }
    //             });
    //             this.itrList = tempArr;
    //         }
    //         if (party.party_type === 7) {
    //             this.selectedItrName = party.itrselected === null ? 'ITR6' : party.itrselected;
    //             const tempArr = [];
    //             this.itrListFull.forEach(element => {
    //                 if (
    //                     element['form_type'] === 'ITR6'
    //                 ) {
    //                     tempArr.push(element);
    //                 }
    //                 if (element['form_type'] === this.selectedItrName) {
    //                     this.selectedItrId = element['id'];
    //                 }
    //             });
    //             this.itrList = tempArr;
    //         }
    //         this.itrList.forEach(element => {
    //             if (element['id'] === this.selectedItrId) {
    //                 this.selectedItr = element;
    //                 this.selectedItrName = element['form_type'];
    //                 this.selectedItrId = element['id'];
    //             }
    //         });
    //         if (this.selectedYearId && this.personID && this.selectedItrId) {
    //             this.router.navigate([], {
    //                 relativeTo: this.activatedRoute,
    //                 queryParams: {
    //                     p_id: this.personID,
    //                     f_id: this.selectedYearId,
    //                     itr_id: this.selectedItrId
    //                 },
    //                 queryParamsHandling: 'merge',
    //             });
    //         }
    //         // this.filterAssessmentYearOnItr(this.selectedItr);
    //         this.navigation.initSideMenu(this.selectedItrId);
    //     }
    // }

    itrOption() {
        const partyType = localStorage.getItem('party_type') || null;
        if (partyType) {
            this.selectedItrId = this.selectedItrId ? this.selectedItrId : parseInt(this.tempItrId, 10);
            const party = JSON.parse(atob(partyType));
            this.partyData = JSON.parse(atob(partyType));
            if (party.party_type === 1) {
                this.ayItrMap.set(1, 'ITR1');
                this.ayItrMap.set(2, 'ITR3');
                this.ayItrMap.set(3, 'ITR3');
                this.selectedItrName = party.itrselected === null ? this.ayItrMap.get(this.selectedYearId) : party.itrselected;
                // console.log('Selected Itr Name: ' + this.selectedItrName);
                const tempArr = [];
                this.itrListFull.forEach(element => {
                    if (this.selectedYearId === 1
                        && (element['form_type'] === 'ITR1' ||
                            element['form_type'] === 'ITR4')) {
                        tempArr.push(element);
                    } else if (this.selectedYearId === 2
                        && (element['form_type'] === 'ITR1' ||
                            element['form_type'] === 'ITR2' ||
                            element['form_type'] === 'ITR3' ||
                            element['form_type'] === 'ITR4')) {
                        tempArr.push(element);
                    } else if (this.selectedYearId === 3
                        && (element['form_type'] === 'ITR1' ||
                            element['form_type'] === 'ITR2' ||
                            element['form_type'] === 'ITR3' ||
                            element['form_type'] === 'ITR4')) {
                        tempArr.push(element);
                    } else if (this.selectedYearId === 4
                        && (element['form_type'] === 'ITR1' ||
                            element['form_type'] === 'ITR2' ||
                            element['form_type'] === 'ITR3' ||
                            element['form_type'] === 'ITR4')) {
                        tempArr.push(element);
                    }
                    if (element['form_type'] === this.selectedItrName) {
                        this.selectedItrId = element['id'];
                    }
                });
                this.itrList = tempArr;
            }
            if (party.party_type === 2) {
                this.selectedItrName = party.itrselected === null ? `ITR3` : party.itrselected;
                // console.log('Selected Itr Name: ' + this.selectedItrName);
                const tempArr = [];
                this.itrListFull.forEach(element => {
                    if (this.selectedYearId === 1
                        && element['form_type'] === 'ITR4') {
                        tempArr.push(element);
                    } else if (this.selectedYearId === 2
                        && (element['form_type'] === 'ITR2' ||
                            element['form_type'] === 'ITR3' ||
                            element['form_type'] === 'ITR4')) {
                        tempArr.push(element);
                    } else if (this.selectedYearId === 3
                        && (element['form_type'] === 'ITR2' ||
                            element['form_type'] === 'ITR3' ||
                            element['form_type'] === 'ITR4')) {
                        tempArr.push(element);
                    } else if (this.selectedYearId === 4
                        && (
                            element['form_type'] === 'ITR2' ||
                            element['form_type'] === 'ITR3' ||
                            element['form_type'] === 'ITR4')) {
                        tempArr.push(element);
                    }
                    if (element['form_type'] === this.selectedItrName) {
                        this.selectedItrId = element['id'];
                    }
                });
                this.itrList = tempArr;
            }
            if (party.party_type === 3) {
                this.ayItrMap.set(1, 'ITR4');
                this.ayItrMap.set(2, 'ITR5');
                this.ayItrMap.set(3, 'ITR5');
                this.selectedItrName = party.itrselected === null ? this.ayItrMap.get(this.selectedYearId) : party.itrselected;
                // console.log('Selected Itr Name: ' + this.selectedItrName);
                const tempArr = [];
                this.itrListFull.forEach(element => {
                    if (this.selectedYearId === 1
                        && element['form_type'] === 'ITR4') {
                        tempArr.push(element);
                    } else if (this.selectedYearId === 2
                        && (element['form_type'] === 'ITR4' ||
                            element['form_type'] === 'ITR5')) {
                        tempArr.push(element);
                    } else if (this.selectedYearId === 3
                        && (element['form_type'] === 'ITR4' ||
                            element['form_type'] === 'ITR5')) {
                        tempArr.push(element);
                    } else if (this.selectedYearId === 4
                        && (
                            element['form_type'] === 'ITR4' ||
                            element['form_type'] === 'ITR5')) {
                        tempArr.push(element);
                    }
                    if (element['form_type'] === this.selectedItrName) {
                        this.selectedItrId = element['id'];
                    }
                });
                this.itrList = tempArr;
            }
            if (party.party_type === 4) {
                this.selectedItrName = party.itrselected === null ? 'ITR5' : party.itrselected;
                // console.log('Selected Itr Name: ' + this.selectedItrName);
                const tempArr = [];
                this.itrListFull.forEach(element => {
                    if (
                        element['form_type'] === 'ITR5'
                    ) {
                        tempArr.push(element);
                    }
                    if (element['form_type'] === this.selectedItrName) {
                        this.selectedItrId = element['id'];
                    }
                });
                this.itrList = tempArr;
            }
            if (party.party_type === 5) {
                this.selectedItrName = party.itrselected === null ? 'ITR5' : party.itrselected;
                const tempArr = [];
                this.itrListFull.forEach(element => {
                    if (
                        element['form_type'] === 'ITR5'
                    ) {
                        tempArr.push(element);
                    }
                    if (element['form_type'] === this.selectedItrName) {
                        this.selectedItrId = element['id'];
                    }
                });
                this.itrList = tempArr;
            } if (party.party_type === 6) {
                this.selectedItrName = party.itrselected === null ? 'ITR5' : party.itrselected;
                const tempArr = [];
                this.itrListFull.forEach(element => {
                    if (
                        element['form_type'] === 'ITR5'
                    ) {
                        tempArr.push(element);
                    }
                    if (element['form_type'] === this.selectedItrName) {
                        this.selectedItrId = element['id'];
                    }
                });
                this.itrList = tempArr;
            }
            if (party.party_type === 7) {
                this.selectedItrName = party.itrselected === null ? 'ITR6' : party.itrselected;
                const tempArr = [];
                this.itrListFull.forEach(element => {
                    if (
                        element['form_type'] === 'ITR6'
                    ) {
                        tempArr.push(element);
                    }
                    if (element['form_type'] === this.selectedItrName) {
                        this.selectedItrId = element['id'];
                    }
                });
                this.itrList = tempArr;
            }
            this.itrList.forEach(element => {
                if (element['id'] === this.selectedItrId) {
                    this.selectedItr = element;
                    this.selectedItrName = element['form_type'];
                    this.selectedItrId = element['id'];
                }
            });
            if (this.selectedYearId && this.personID && this.selectedItrId) {
                this.router.navigate([], {
                    relativeTo: this.activatedRoute,
                    queryParams: {
                        p_id: this.personID,
                        f_id: this.selectedYearId,
                        itr_id: this.selectedItrId
                    },
                    queryParamsHandling: 'merge',
                });
            }
            // this.filterAssessmentYearOnItr(this.selectedItr);
            this.navigation.initSideMenu(this.selectedItrId);
        }
    }

    changeItr(itr) {
        (Swal as any)
            .fire({
                title: 'Are you sure?',
                text: 'Due to ITR switching some data may get change. Please verify your data',
                icon: 'question',
                showCancelButton: true,
                allowOutsideClick: false,
                keydownListenerCapture: true,
                backdrop: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            })
            .then(result => {
                if (result.value) {
                    // this.filterAssessmentYearOnItr(itr);
                    this.message.loading = true;
                    this.api.put(`personal_service/itr_selection/${this.auth.token_data['personId']}/${this.selectedYearId}/${itr.form_type}/${itr.id}`, null)
                        .subscribe(
                            res => {
                                if (res['status']) {
                                    localStorage.setItem('party_type', btoa(JSON.stringify(res['data'])));
                                    this.itrOption();
                                }
                                this.router.navigate(['dashboard/part-general/personal-information/personal-information.component'], {
                                    queryParams: {
                                        p_id: this.personID,
                                        f_id: this.selectedYearId,
                                        itr_id: this.selectedItrId,
                                    },
                                    queryParamsHandling: 'merge',
                                });
                                this.message.loading = false;
                            },
                            err => {
                                this.message.loading = false;
                                this.message.displaySnackbar('Unable to change ITR!');
                            }
                        );
                }
            });
    }

    // if we run some itr with some assessment year  start

    filterAssessmentYearOnItr(itr) {
        if (this.allassessmentYearList != null && this.allassessmentYearList.length > 0) {
            this.assessmentYearList = [...this.allassessmentYearList];
            const previousAssessmentYear = this.assessmentYearList.pop();
            previousAssessmentYear.selected_year = 0;
            this.assessmentYearList.splice(0, 1);
            this.selectedYearId = this.assessmentYearList[0].id;
            this.selectedAssessmentYear = this.assessmentYearList[0];
            this.assessmentYear = this.assessmentYearList[0].assessment_year ? this.assessmentYearList[0].assessment_year.split('-')[0] : '';
            // this.selectedAssessmentYear.selected_year = 1;
            // const assessmentYears = [previousAssessmentYear, this.selectedAssessmentYear];
            // this.updateAssessmentYear(assessmentYears);
            this.updateAssessmentYear(this.selectedAssessmentYear, this.personID);
        }
    }

    filterAssesmentYear() {
        if (this.allassessmentYearList != null && this.allassessmentYearList.length > 0) {
            this.assessmentYearList = [...this.allassessmentYearList];
            const previousAssessmentYear = this.assessmentYearList.pop();
            previousAssessmentYear.selected_year = 0;
            this.assessmentYearList.splice(0, 1);
            this.selectedYearId = this.assessmentYearList[0].id;
            this.selectedAssessmentYear = this.assessmentYearList[0];
            this.assessmentYear = this.assessmentYearList[0].assessment_year ? this.assessmentYearList[0].assessment_year.split('-')[0] : '';
            // this.selectedAssessmentYear.selected_year = 1;
            // const assessmentYears = [previousAssessmentYear, this.selectedAssessmentYear];
            // this.updateAssessmentYear(assessmentYears);
            this.updateAssessmentYear(this.selectedAssessmentYear, this.personID);
        }
    }

    // if we run some itr with some assessment year end

    getAssessmentYearList() {
        const partyType = localStorage.getItem('party_type') || null;
        if (partyType) {
            this.assessmentYearList = [];
            this.message.loading = true;
            this.api.get('assessmentyears/data').subscribe(
                res => {
                    this.message.loading = false;
                    if (res['status']) {
                        this.assessmentYearList = res['data'];
                        this.allassessmentYearList = [...this.assessmentYearList];
                        console.log("assesmentYearList" + this.assessmentYearList);
                        // this.filterAssesmentYear();
                        const party = JSON.parse(atob(partyType));
                        let found = false;
                        this.assessmentYearList.forEach(element => {
                            if (element['id'] === party['financial_id']) {
                                found = true;
                                this.selectAssessmentYear(element, false, false);
                            }
                        });
                        if (this.selectedYearId && !found) {
                            this.selectAssessmentYear(this.selectedAssessmentYear, false, false);
                        }
                    } else {
                        this.message.displaySnackbar(res['message']);
                    }
                },
                err => {
                    this.message.loading = false;
                    this.message.displaySnackbar('Oops, Something went wrong!');
                }
            );
        }
    }

    checkboxList(isImportButton) {
        return new Promise((resolve, reject) => {
            this.getWhichDataCanImport(this.personID, (isImportButton) ? this.selectedAssessmentYear.id - 1 : this.selectedAssessmentYear.id).then(data => {
                let dataWithCheckbox = {};
                let checkboxes = '';
                if (data['personalInfo']) {
                    checkboxes += `<div class="swal-input-label"><input type="checkbox" id="personalInfoCheckboxID" class="swal-input" value="Personal Information"> Personal Information</div>`;
                }
                if (data['bankingInfo']) {
                    checkboxes += `<div class="swal-input-label"><input type="checkbox" id="bankingInfoCheckboxID" class="swal-input" value="Banking Information"> Banking Information</div>`;
                }
                if (data['employerInfo']) {
                    checkboxes += `<div class="swal-input-label"><input type="checkbox" id="employerInfoCheckboxID" class="swal-input" value="Employer"> Employer Information</div>`;
                }
                if (data['hpInfo']) {
                    checkboxes += `<div class="swal-input-label"><input type="checkbox" id="hpInfoCheckboxID" class="swal-input" value="House Property"> House Property Information</div>`;
                }
                if (data['singinPersonInfo']) {
                    checkboxes += `<div class="swal-input-label"><input type="checkbox" id="signinCheckboxID" class="swal-input" value="Signing Person Info"> Signing Person info</div>`;
                }
                if (data['deductions']) {
                    checkboxes += `<div class="swal-input-label"><input type="checkbox" id="deductionCheckboxID" class="swal-input" value="Deductions"> Deductions</div>`;
                }
                if (data['bpInfo']) {
                    checkboxes += `<div class="swal-input-label" id="business"><input type="checkbox" id="bpCheckboxID" class="swal-input" value="Business"> Business and professional Information</div>`;
                }
                dataWithCheckbox['existModule'] = data;
                dataWithCheckbox['checkboxes'] = checkboxes;
                resolve(dataWithCheckbox);
            }).catch(err => {
                reject();
            });
        });
    }


    imoprtPopup(year, isSelect, data, isImportButton) {
        let canModifyFinancialYearData = false;
        this.assessmentYearList.forEach((element) => {
            if (this.selectedItrId === 2 || this.selectedItrId === 3 || year['id'] > element['id']) {
                canModifyFinancialYearData = true;
            }
        });
        if (canModifyFinancialYearData) {
            (Swal as any).fire({
                title: 'Please select to import data from previous assessment year',
                showCancelButton: true,
                allowOutsideClick: false,
                keydownListenerCapture: true,
                backdrop: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                html: `
                                <div class="swal-form">
                                    <div class="swal-input-label" id="swal_select_all"><input type="checkbox" id="swal-input0" class="swal-input" value="Banking Information"> Select all</div>`
                    + data['checkboxes']
                    + `</div>`
                ,
                preConfirm: () => {
                    const arr = {};

                    if (data['existModule']['personalInfo']) {
                        arr['personalInfo'] = {
                            key: document.getElementById('personalInfoCheckboxID')['value'],
                            value: document.getElementById('personalInfoCheckboxID')['checked']
                        };
                    }
                    if (data['existModule']['bankingInfo']) {
                        arr['bankingInfo'] = {
                            key: document.getElementById('bankingInfoCheckboxID')['value'],
                            value: document.getElementById('bankingInfoCheckboxID')['checked']
                        };
                    }
                    if (data['existModule']['bpInfo']) {
                        arr['bpInfo'] = {
                            key: document.getElementById('bpCheckboxID')['value'],
                            value: document.getElementById('bpCheckboxID')['checked']
                        };
                    }
                    if (data['existModule']['deductions']) {
                        arr['deductions'] = {
                            key: document.getElementById('deductionCheckboxID')['value'],
                            value: document.getElementById('deductionCheckboxID')['checked']
                        }
                    }
                    if (data['existModule']['employerInfo']) {
                        arr['employerInfo'] = {
                            key: document.getElementById('employerInfoCheckboxID')['value'],
                            value: document.getElementById('employerInfoCheckboxID')['checked']
                        }
                    }
                    if (data['existModule']['hpInfo']) {
                        arr['hpInfo'] = {
                            key: document.getElementById('hpInfoCheckboxID')['value'],
                            value: document.getElementById('hpInfoCheckboxID')['checked']
                        };
                    }
                    if (data['existModule']['singinPersonInfo']) {
                        arr['singinPersonInfo'] = {
                            key: document.getElementById('signinCheckboxID')['value'],
                            value: document.getElementById('signinCheckboxID')['checked']
                        };
                    }

                    return arr;
                }
            }).then((formValues) => {
                if (formValues['isConfirmed']) {
                    const previousAssessmentYear = (isImportButton) ? this.selectedAssessmentYear.id - 1 : this.changeAssessmentYear(year, isSelect);
                    const obj = {
                        person_id: this.personID,
                        selectAssessmentYearid: this.selectedAssessmentYear.id,
                        previousAssessmentYearid: (isImportButton) ? previousAssessmentYear : previousAssessmentYear.id,
                        personalinformation: formValues.value['personalInfo'] ? formValues.value['personalInfo'].value : false,
                        bankinginformation: formValues.value['bankingInfo'] ? formValues.value['bankingInfo'].value : false,
                        employer: formValues.value['employerInfo'] ? formValues.value['employerInfo'].value : false,
                        houseProperty: formValues.value['hpInfo'] ? formValues.value['hpInfo'].value : false,
                        singningpersoninfo: formValues.value['singinPersonInfo'] ? formValues.value['singinPersonInfo'].value : false,
                        deductions: formValues.value['deductions'] ? formValues.value['deductions'].value : false,
                        businessAndProfessional: formValues.value['bpInfo'] ? formValues.value['bpInfo'].value : false
                    }
                    this.message.loading = true;
                    this.api.post('assessmentyearsdatasave/update_data', obj).subscribe(
                        res => {
                            this.message.loading = false;
                            this.updateNavigationSideMenu(isSelect);
                            this.getAndUpdateParty(this.personID, this.selectedAssessmentYear.id);
                        }, err => {
                            this.message.loading = false;
                            this.message.displaySnackbar('Oops, Something went wrong!');
                        });
                }
            });
            this.initDomEvent(data);
        } else {
            this.changeAssessmentYear(year, isSelect);
            this.updateNavigationSideMenu(isSelect);

        }
    }



    async selectAssessmentYear(year, isSelect, isImportButton) {
        console.log("working.........");
        if (isSelect && (isImportButton || this.partyData.isImported === undefined || this.partyData.isImported == null || !this.partyData.isImported)) {
            const ay = (isImportButton) ? this.selectedAssessmentYear.id - 1 : this.selectedAssessmentYear.id;
            this.checkboxList(isImportButton).then(checkBoxData => {
                if (checkBoxData['checkboxes'] !== '' && ay < year['id']) {
                    this.imoprtPopup(year, isSelect, checkBoxData, isImportButton);
                } else if (isImportButton) {
                    this.message.displayInfoToaster('You don\'t have any previous assessment year data to import.');
                } else if (!isImportButton) {
                    this.changeAssessmentYear(year, isSelect);
                    this.updateNavigationSideMenu(isSelect);
                } else if (!isImportButton) {
                    this.getAddress(this.personID, year['id']).then(address => {
                        if (address == null) {
                            this.openAutoItrForm('autoItrbtn');
                        }
                    });
                }
            });
        } else {
            this.changeAssessmentYear(year, isSelect);
            this.updateNavigationSideMenu(isSelect);
        }
    }


    changeAssessmentYear(year, isSelect) {
        this.changesFromFinancial = false;
        const previousAssessmentYear = this.selectedAssessmentYear;
        this.assessmentYearList.forEach(element => {
            // if (element.selected_year === 1 && isSelect) {
            //     previousAssessmentYear = element;
            //     previousAssessmentYear.selected_year = 0;
            // }
            if (element.id === year['id']) {
                this.selectedAssessmentYear = element;
                // this.selectedAssessmentYear.selected_year = 1;
                this.selectedYearId = element.id;
                this.assessmentYear = element.assessment_year ? element.assessment_year.split('-')[0] : '';
            }
        });
        localStorage.setItem('financial_year', btoa(JSON.stringify(this.selectedAssessmentYear)));
        this.updateAssessmentYear(this.selectedAssessmentYear, this.personID);
        if (isSelect) {
            this.getAndUpdateParty(this.personID, this.selectedAssessmentYear.id);
        }
        return previousAssessmentYear;
    }

    initDomEvent(data) {
        document.getElementById('swal-input0').addEventListener('click', () => {
            console.log("click");
            if (document.getElementById('swal-input0')['checked']) {
                document.getElementById('swal-input0')['checked'] = true;
                if (data['existModule']['personalInfo']) {
                    document.getElementById('personalInfoCheckboxID')['checked'] = true;
                }
                if (data['existModule']['bankingInfo']) {
                    document.getElementById('bankingInfoCheckboxID')['checked'] = true;
                }
                if (data['existModule']['employerInfo']) {
                    document.getElementById('employerInfoCheckboxID')['checked'] = true;
                }
                if (data['existModule']['hpInfo']) {
                    document.getElementById('hpInfoCheckboxID')['checked'] = true;
                }
                if (data['existModule']['singinPersonInfo']) {
                    document.getElementById('signinCheckboxID')['checked'] = true;
                }
                if (data['existModule']['deductions']) {
                    document.getElementById('deductionCheckboxID')['checked'] = true;
                }
                if (data['existModule']['bpInfo']) {
                    document.getElementById('bpCheckboxID')['checked'] = true;
                }
            } else {
                document.getElementById('swal-input0')['checked'] = false;
                if (data['existModule']['personalInfo']) {
                    document.getElementById('personalInfoCheckboxID')['checked'] = false;
                }
                if (data['existModule']['bankingInfo']) {
                    document.getElementById('bankingInfoCheckboxID')['checked'] = false;
                }
                if (data['existModule']['employerInfo']) {
                    document.getElementById('employerInfoCheckboxID')['checked'] = false;
                }
                if (data['existModule']['hpInfo']) {
                    document.getElementById('hpInfoCheckboxID')['checked'] = false;
                }
                if (data['existModule']['singinPersonInfo']) {
                    document.getElementById('signinCheckboxID')['checked'] = false;
                }
                if (data['existModule']['deductions']) {
                    document.getElementById('deductionCheckboxID')['checked'] = false;
                }
                if (data['existModule']['bpInfo']) {
                    document.getElementById('bpCheckboxID')['checked'] = false;
                }
            }
        });


        if (data['existModule']['personalInfo']) {
            document.getElementById('personalInfoCheckboxID').addEventListener('click', () => {

                this.isAllChecked(data);
            });
        }
        if (data['existModule']['bankingInfo']) {
            document.getElementById('bankingInfoCheckboxID').addEventListener('click', () => {

                this.isAllChecked(data);
            });
        }
        if (data['existModule']['employerInfo']) {
            document.getElementById('employerInfoCheckboxID').addEventListener('click', () => {

                this.isAllChecked(data);
            });
        }


        if (data['existModule']['hpInfo']) {
            document.getElementById('hpInfoCheckboxID').addEventListener('click', () => {

                this.isAllChecked(data);
            });
        }
        if (data['existModule']['singinPersonInfo']) {
            document.getElementById('signinCheckboxID').addEventListener('click', () => {

                this.isAllChecked(data);
            });
        }
        if (data['existModule']['deductions']) {
            document.getElementById('deductionCheckboxID').addEventListener('click', () => {

                this.isAllChecked(data);
            });
        }
        if (data['existModule']['bpInfo']) {
            document.getElementById('bpCheckboxID').addEventListener('click', () => {

                this.isAllChecked(data);
            });
        }
    }



    isAllChecked(data) {

        let allSelected = true;


        if (data['existModule']['personalInfo']
            && !document.getElementById('personalInfoCheckboxID')['checked']
        ) {
            allSelected = false;
        }
        if (data['existModule']['bankingInfo']
            && !document.getElementById('bankingInfoCheckboxID')['checked']
        ) {
            allSelected = false;
        }
        if (data['existModule']['employerInfo']
            && !document.getElementById('employerInfoCheckboxID')['checked']
        ) {
            allSelected = false;
        }
        if (data['existModule']['hpInfo']
            && !document.getElementById('hpInfoCheckboxID')['checked']
        ) {
            allSelected = false;
        }
        if (data['existModule']['singinPersonInfo']
            && !document.getElementById('signinCheckboxID')['checked']
        ) {
            allSelected = false;
        }
        if (data['existModule']['deductions']
            && !document.getElementById('deductionCheckboxID')['checked']
        ) {
            allSelected = false;
        }
        if (data['existModule']['bpInfo']
            && !document.getElementById('bpCheckboxID')['checked']
        ) {
            allSelected = false;
        }

        if (!allSelected) {
            document.getElementById('swal-input0')['checked'] = false;
        } else document.getElementById('swal-input0')['checked'] = true;
    }

    updateNavigationSideMenu(isSelect) {
        if (this.selectedYearId && this.personID && this.selectedItrId) {
            if (isSelect) {
                this.router.navigate(['dashboard/part-general/personal-information/personal-information.component'], {
                    relativeTo: this.activatedRoute,
                    queryParams: {
                        p_id: this.personID,
                        f_id: this.selectedYearId,
                        itr_id: this.selectedItrId
                    },
                    queryParamsHandling: 'merge',
                });
            } else {
                this.router.navigate([], {
                    relativeTo: this.activatedRoute,
                    queryParams: {
                        p_id: this.personID,
                        f_id: this.selectedYearId,
                        itr_id: this.selectedItrId
                    },
                    queryParamsHandling: 'merge',
                });
            }
        }
        this.navigation.initSideMenu(this.selectedItrId);
    }

    updateAssessmentYear(assessmentYear, personId) {
        const personAy = {
            personId: personId,
            ayId: assessmentYear.id
        };
        this.message.loading = true;
        this.api.post('assessmentyears/update', personAy).subscribe(
            res => {
                this.message.loading = false;
            },
            err => {
                this.message.loading = false;
                this.message.displaySnackbar('Oops, Something went wrong!');
            }
        );
    }

    formatTime(value) {
        const time = value.split(':');
        let hour = parseInt(time[0], 10);
        const minute = parseInt(time[1], 10);

        let returnTime: any;
        let displayHour: any;
        let displayMinute: any;

        if (hour > 12) {
            hour = hour - 12;
        }

        if (hour < 10) {
            displayHour = `0${hour}`;
        } else {
            displayHour = `${hour}`;
        }
        if (minute < 10) {
            displayMinute = `0${minute}`;
        } else {
            displayMinute = `${minute}`;
        }
        if (parseInt(time[0], 10) === 0 && minute === 0) {
            returnTime = `12:00 AM`;
        } else if (parseInt(time[0], 10) < 12) {
            returnTime = `${displayHour}:${displayMinute} AM`;
        } else if (parseInt(time[0], 10) === 12 && minute === 0) {
            returnTime = `12:00 PM`;
        } else if (parseInt(time[0], 10) === 12 && minute > 0) {
            returnTime = `${displayHour}:${displayMinute} PM`;
        } else if (parseInt(time[0], 10) > 12) {
            returnTime = `${displayHour}:${displayMinute} PM`;
        }
        return returnTime;
    }

    formatDate(value, format = 'dd-mm-yyyy') {
        if (value) {
            const fullDate = new Date(value);
            const year = fullDate.getFullYear();
            const month = fullDate.getMonth() + 1 < 10 ? '0' + (fullDate.getMonth() + 1) : fullDate.getMonth() + 1;
            const date = fullDate.getDate() < 10 ? '0' + fullDate.getDate() : fullDate.getDate();
            if (format === 'dd-mm-yyyy') {
                return date + '-' + month + '-' + year;
            }
            if (format === 'mm-dd-yyyy') {
                return month + '-' + date + '-' + year;
            }
            if (format === 'dd/mm/yyyy') {
                return date + '/' + month + '/' + year;
            }
            if (format === 'mm/dd/yyyy') {
                return month + '/' + date + '/' + year;
            }
            if (format === 'yyyy-mm-dd') {
                return year + '-' + month + '-' + date;
            }
            if (format === 'yyyy-dd-mm') {
                return year + '-' + date + '-' + month;
            }
            if (format === 'yyyy/mm/dd') {
                return year + '/' + month + '/' + date;
            }
            if (format === 'yyyy/dd/mm') {
                return year + '/' + date + '/' + month;
            }
            return fullDate;
        } else {
            return null;
        }
    }

    getCountryList() {
        return new Promise((resolve, reject) => {
            this.api.get('state/country_list').subscribe(
                res => {
                    this.country_list = null;
                    if (res['status']) {
                        this.country_list = res['data'];
                        return resolve(res);
                    } else {
                        this.message.loading = false;
                        this.message.displaySnackbar(res['message']);
                        return reject(res);
                    }
                },
                err => {
                    reject(reject);
                    this.message.loading = false;
                    this.message.displaySnackbar('Oops, Something went wrong!');
                    reject(reject);
                    return reject;
                }
            );
        });
    }

    autoFillPincode(pincode) {
        if (pincode.toString().length === 6) {
            return new Promise((resolve, reject) => {
                this.api.get(`state/pincode/${pincode}`).subscribe(
                    res => {
                        this.message.loading = false;
                        resolve(res);
                        if (res['status']) {
                            if (res['data'] != null) {
                                this.pincodeData = res['data'];
                            }
                        } else {
                            this.message.displaySnackbar(res['message']);
                        }
                    },
                    err => {
                        this.message.loading = false;
                        this.message.displaySnackbar('Oops, Something went wrong!');
                        reject(err);
                    }
                );
            });
        }
    }

    getStateList() {
        if (this.state_list.length === 0) {
            return new Promise((resolve, reject) => {
                this.api.get('state/statelist').subscribe(
                    res => {
                        this.state_list = null;
                        if (res['status']) {
                            this.state_list = res['data'];
                            return resolve;
                        } else {
                            this.message.loading = false;
                            this.message.displaySnackbar(res['message']);
                            return reject;
                        }
                    },
                    err => {
                        this.message.loading = false;
                        this.message.displaySnackbar('Oops, Something went wrong!');
                        return reject;
                    }
                );
            });
        }
    }


    // will take constant amount of time( O(n) ) n -> no. of keys
    convertDates(data, dateKeys) {
        if (data instanceof Object) {
            Object.keys(data).forEach(key => {
                let found = false;
                dateKeys.forEach(dateKey => {

                    if (dateKey == key && data[key]) {
                        found = true;
                        data[key] = this.formatDate(data[key], 'yyyy-mm-dd');
                    }
                });

                if (!found && (data[key] instanceof Object || data[key] instanceof Array)) {
                    this.convertDates(data[key], dateKeys);
                }
            });
        } else if (data instanceof Array) {
            data.forEach(value => {
                this.convertDates(value, dateKeys);
            });
        }
    }

    // will take constant amount of time( O(n) ) n -> no. of keys
    convertDatesFromBsDate(data, dateKeys) {
        if (data instanceof Object) {
            Object.keys(data).forEach(key => {
                if (data[key] instanceof Object || data[key] instanceof Array) {
                    this.convertDatesFromBsDate(data[key], dateKeys);
                } else {
                    dateKeys.forEach(dateKey => {
                        if (dateKey === key && data[key]) {
                            data[key] = new Date(data[key]);
                        }
                    });
                }
            });
        } else if (data instanceof Array) {
            data.forEach(value => {
                this.convertDatesFromBsDate(value, dateKeys);
            });
        }
    }

    checkIsNavDisabled() {
        if (this.navDisable) {
            return true;
        }
        if (window.location.href.indexOf('computation-display') > -1 || window.location.href.indexOf('sigining-person-info') > -1 || window.location.href.indexOf('return-filing') > -1) {
            return true;
            this.navDisable = true;
        } else {
            return false;
        }
    }


    setIDs(data, personId, financialId) {

        if (data instanceof Object) {
            Object.keys(data).forEach(key => {
                if (data[key] instanceof Object || data[key] instanceof Array) {
                    this.setIDs(data[key], personId, financialId);
                } else if ('person_id' === key) {
                    data[key] = personId;
                } else if ('personId' === key) {
                    data[key] = personId;
                } else if ('financial_id' === key) {
                    data[key] = financialId;
                } else if ('financialId' === key) {
                    data[key] = financialId;
                }
            });
        } else if (data instanceof Array) {
            data.forEach(value => {
                this.setIDs(value, personId, financialId);
            });
        }
    }

    zeroIfNull(value) {
        if (value) { return value; }
        return 0;
    }

    sum(array) {
        let sum = 0;
        if (array) {
            array.forEach(value => {
                sum += this.zeroIfNeg(value);
            });
        }
        return sum;
    }

    min(array) {
        let min = array[0];
        if (array) {
            array.forEach(value => {
                min = Math.min(min, this.zeroIfNull(value));
            });
        }
        return min;
    }

    zeroIfNeg(value) {
        if (value == null || !value || value < 0) { return 0; }
        return value;
    }


    // will take constant amount of time( O(n) ) n -> no. of keys
    setID(data, personId, financialId) {
        if (data instanceof Object) {

            data['financialId'] = parseInt(financialId, 10);
            data['financial_id'] = parseInt(financialId, 10);

            data['personId'] = parseInt(personId, 10);
            data['person_id'] = parseInt(personId, 10);

            Object.keys(data).forEach(key => {
                if (data[key] instanceof Object || data[key] instanceof Array) {
                    this.setID(data[key], personId, financialId);
                }
            });
        } else if (data instanceof Array) {
            data.forEach(value => {
                this.setID(value, personId, financialId);
            });
        }
    }

    // this is used for itr5 sub status 
    getSubStatus(p_id, f_id) {
        let subStatusList: any[] = [
            { id: 0, value: "NA" },
            { id: 1, value: "Select" },
            { id: 10, value: "Partnership firm" },
            { id: 5, value: "Limited Liability Partnership (LLP)" },
            { id: 8, value: "Any other AOP/BOI" },
            { id: 15, value: "Primary Agricultural Credit Society" },
            { id: 16, value: "Primary Co-operative Agricultural and Rural Development bank" },
            { id: 17, value: "Other Cooperative Bank" },
            { id: 4, value: "Other Cooperative Society" },
            { id: 11, value: "Society Registered under Societies Registration Act-1860 or any law corresponding to that state" },
            { id: 13, value: "Trust other than trust eligible to file return in ITR-7" },
            { id: 20, value: "Business Trust" },
            { id: 21, value: "Investment Fund" },
            { id: 19, value: "Other AJP" },
            { id: 18, value: "Estate of the insolvent" },
            { id: 12, value: "Estate of Decreased" }
        ];
        this.api.get(`personal_service/detail/${p_id}/${f_id}`).subscribe(
            res => {
                this.message.loading = false;
                if (res['status']) {
                    this.storeData = res['data'];
                    this.subStatus = res['data'].sub_status;
                    subStatusList.forEach(e => {
                        if (this.subStatus == e.value) {
                            this.substatusId = e.id;
                            console.log('sub status', this.subStatus);
                        }
                    });
                    console.log('sub status', this.subStatus);
                    console.log('sub status', this.substatusId);
                    if (this.selectedItrId == 5) {
                        this.pmtInfoEnableDisbale();
                        this.ttiServiceHideAndUnhide();
                        if (this.substatusId == 15 || this.substatusId == 16 || this.substatusId == 4) {
                            this.substatusdisable = false;
                        }
                        else {
                            this.substatusdisable = true;
                        }
                        if (this.substatusId == 5) {
                            this.substatusllp = false;
                            this.pmtdesignation = false;
                        }
                        else {
                            this.substatusllp = true;
                            this.pmtdesignation = true;
                        }
                        if (this.substatusId == 21) {
                            this.disbalecfl = false;
                        }
                        else {
                            this.disbalecfl = true;
                        }

                        if (this.substatusId == 4) {
                            this.otherInfodisable = false;
                            this.oivaibale = 2;
                        }
                        else {
                            this.otherInfodisable = true;
                            this.oivaibale = 122;
                        }

                        if (this.substatusId == 15 || this.substatusId == 16 || this.substatusId == 17) {
                            this.bpdisable = false;
                        }
                        else {
                            this.bpdisable = true;
                        }

                        if (this.substatusId == 10) {
                            this.pldisable = false;
                            this.pl4ada = 2;
                        }
                        else {
                            this.pldisable = true;
                            this.pl4ada = 111;
                        }

                        if (this.storeData.status == 'Local Authority' || this.substatusId == 12 || this.substatusId == 19 || this.substatusId == 18) {
                            this.deduction80GGC = true;
                        }
                        else {
                            this.deduction80GGC = false;
                        }

                        if (this.storeData.status == 'Local Authority' || this.storeData.status == 'AOP' || this.storeData.status == 'AJP' || this.storeData.status == 'Firm') {
                            this.deductionEEAEEB = true;
                        }
                        else {
                            this.deductionEEAEEB = false;
                        }

                        if (this.selectedItrId > 2) {
                            if (this.storeData.status == 'AOP' && (this.substatusId == 4 || this.substatusId == 17 || this.substatusId == 1 || this.substatusId == 16)) {
                                this.isApplicableForItr5 = true;
                            } else {
                                this.isApplicableForItr5 = false;
                            }
                        }
                    }
                    if (this.selectedItrId == 6) {
                        if (this.storeData.type_of_company == "Y" || this.storeData.type_of_company == "N") {
                            this.companyStatus = true;
                            this.substatusllp = false;
                            this.producerComapny = true;
                        }
                        else {
                            this.companyStatus = false;
                            this.substatusllp = false;
                            this.producerComapny = false;
                        }
                    }

                }
            },
            err => {
                this.message.loading = false;
            }
        );

    }

    pmtInfoEnableDisbale() {
        this.pmtInfoA = false;
        this.pmtInfoB = false;
        this.pmtInfoC = false;
        this.pmtInfoD = false;
        this.pmtInfoE = false;
        this.pmtpartnertwo = false;
        if (this.storeData.status == 'AOP' && (this.substatusId == 15 || this.substatusId == 17 || this.substatusId == 16 || this.substatusId == 11 || this.substatusId == 4)) {
            this.pmtInfoB = true;
            this.pmtInfoC = true;
            this.pmtInfoE = true;
        }
        if (this.storeData.status == 'AOP' && (this.substatusId == 8 || this.substatusId == 20 || this.substatusId == 21)) {
            this.pmtInfoE = true;
        }
        if (this.storeData.status == 'AOP' && (this.substatusId == 13)) {
            this.pmtInfoB = true;
        }
        if (this.storeData.status == 'Firm' && (this.substatusId == 10 || this.substatusId == 5)) {
            this.pmtInfoB = true;
            this.pmtInfoC = true;
            this.pmtInfoE = true;
        }
        if (this.storeData.status == 'AJP' && (this.substatusId == 12)) {
            this.pmtInfoA = true;
            this.pmtInfoE = true;
        }
        if (this.storeData.status == 'AJP' && (this.substatusId == 18)) {
            this.pmtInfoA = true;
            this.pmtInfoB = true;
            this.pmtInfoC = true;
            this.pmtInfoE = true;
        }
        if (this.storeData.status == 'AJP' && (this.substatusId == 19)) {
            this.pmtInfoA = true;
            this.pmtInfoB = true;
            this.pmtInfoC = true;
            // this.pmtInfoD = true;
            this.pmtInfoE = true;
        }
        if (this.storeData.status == 'Local Authority') {
            this.pmtInfoA = true;
            this.pmtInfoB = true;
            this.pmtInfoC = true;
            // this.pmtInfoD = true;
            this.pmtInfoE = true;
        }
        if (this.storeData.status == 'Firm' || this.storeData.status == 'AOP') {
            this.pmtpartnertwo = true;
        }
    }

    ttiServiceHideAndUnhide() {
        this.specialRatetti = false;
        this.normalratetti = false;
        this.agrIncometti = false;
        if ((this.storeData.status == 'AOP' || this.storeData.status == 'AJP') && (this.substatusId == 13 || this.substatusId == 12 || this.substatusId == 18)) {
            this.normalratetti = true;
            this.specialRatetti = true;
            this.agrIncometti = true;

        }
    }
    getAndUpdateParty(p_id, f_id) {
        this.api.get(`personal_service/detail/${p_id}/${f_id}`).subscribe(
            res => {
                this.message.loading = false;
                if (res['status']) {
                    if (res['data']) {
                        localStorage.setItem('party_type', btoa(JSON.stringify(res['data'])));
                        this.partyData = res['data'];
                        const neway = (f_id === 3 && (this.partyData.selected_itr_id != null && (this.partyData.selected_itr_id === 1 || this.partyData.selected_itr_id === 2 || this.partyData.selected_itr_id === 3 || this.partyData.selected_itr_id === 4)));
                        if ((neway || f_id !== 3)) {
                            window.location.reload();
                        }
                    }
                } else {
                    this.message.displaySnackbar(res['message']);
                }
            },
            err => {
                this.message.loading = false;
            }
        );
    }

    getWhichDataCanImport(p_id, f_id) {
        return new Promise((resolve, reject) => {
            this.api.get(`assessmentyearsdatasave/data_exist?personId=${p_id}&financialId=${f_id}`).subscribe(
                res => {
                    this.message.loading = false;
                    if (res['status']) {

                        resolve(res['data']);

                    } else {
                        this.message.displaySnackbar(res['message']);
                        reject();
                    }
                },
                err => {
                    this.message.loading = false;
                    reject();
                }
            );
        });
    }

    getAddress(p_id, f_id) {
        return new Promise((resolve, reject) => {
            this.api.get(`personal_service/address/${p_id}/${f_id}`).subscribe(
                res => {
                    this.message.loading = false;
                    if (res['status']) {
                        resolve(res['data']);
                    } else {
                        this.message.displaySnackbar(res['message']);
                        reject();
                    }
                },
                err => {
                    this.message.loading = false;
                    reject();
                });
        });
    }

    openAutoItrForm(id) {
        const element: HTMLElement = document.getElementById(id) as HTMLElement;
        element.click();
    }

    set setSubMenuValue(subMenu: SubMenuStatus) {
        this.subMenuValue.next(subMenu);
    }

    passValueToSubMenu(value, name: String) {
        const subMenu = new SubMenuStatus();
        let moduleName = null;
        if (name.includes(':')) {
            moduleName = name.split(':');
            name = moduleName[0];
        }
        if (typeof value === 'string') {
            if (value.toUpperCase() === 'YES') {
                subMenu.isVisible = true;
            } else {
                subMenu.isVisible = false;
            }
        } else {
            subMenu.isVisible = value;
        }
        subMenu.sumMenuName = name;
        if (moduleName !== null && moduleName[1] === 'N') {
            subMenu.isDisplayNone = true;
        } else {
            subMenu.isDisplayNone = false;
        }
        this.setSubMenuValue = subMenu;

        if ((name === 'Schedule AL2' || name === 'Schedule SH2') && value) {
            subMenu.sumMenuName = (name === 'Schedule AL2') ? 'Schedule AL1' : 'Schedule SH1';
            subMenu.isVisible = false;

            if (moduleName !== null && moduleName[1] === 'N') {
                subMenu.isDisplayNone = true;
            } else {
                subMenu.isDisplayNone = false;
            }
            this.setSubMenuValue = subMenu;
        }
    }

    getSubMenuStatus(p_id, f_id, isReturn) {
        return new Promise((resolve, reject) => {
            this.message.loading = true;
            this.api.get(`user_profile/submenu/${p_id}/${f_id}/${this.selectedItrId}`).subscribe(res => {
                this.message.loading = false;
                if (res['status']) {
                    const subMenuStatus = res['data'];
                    if (isReturn) {
                        resolve(subMenuStatus);
                    } else {
                        // tslint:disable-next-line: forin
                        for (const menu in subMenuStatus) {
                            if (menu === 'TYPE_OF_COMPANY') {
                                this.isTypeOfCompany = subMenuStatus[menu];
                            } else {
                                this.passValueToSubMenu(subMenuStatus[menu], menu);
                            }
                        }
                    }
                }
            }, err => {
                this.message.loading = false;
                reject();
            });
        });
    }

    getAllParties() {
        return new Promise((resolve, reject) => {
            this.api.get(`personal_service/parties`).subscribe(res => {
                if (res['status'] && res['data'] != null) {
                    this.partyMapValue = res['data'];
                    resolve(res['data']);
                } else {
                    this.message.displayErrorToaster(res['message']);
                    reject(false);
                }
            },
                err => {
                    this.message.displayErrorToaster('Error while getting Parties, Please try again!');
                    reject(false);
                });
        });
    }

    set partyMapValue(partyMap) {
        this.partyMap = partyMap;
    }

    get partyMapValue() {
        return this.partyMap;
    }

    getFilingInfoStatus(p_id, f_id) {
        return new Promise((resolve, reject) => {
            this.api.get(`tax_return/filingInformation?personId=${p_id}&financialId=${f_id}`).subscribe(res => {
                if (res['status']) {
                    if (res['data']) {
                        resolve(res['data']['taxReturnDto']);
                    }
                }
            }, err => {
                reject(err);
            });
        });
    }
}
